import { useState } from "react";
import CommonMessage from "../../../common/CommonMessage";
//import { useNavigate } from "react-router-dom";
import { addRole } from "../../../services/roleService";

const RoleAdd = () => {
    const [formData, setFormData] = useState({
        name: "",
        status: "",
    });

    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear field error while typing
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    // Form validation
    const validate = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = "Name field is required";
        }

        if (formData.status === "") {
            newErrors.status = "Please select status";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        const payload = {
            roleName: formData.name.trim(),
            status: formData.status === "true",
        };

        try {
            setLoading(true);
            setMessage("");

            const response = await addRole(payload);

            if (response?.statusCode === 200) {
                setMessage(response.message || "Role added successfully");

                // Reset form
                setFormData({
                    name: "",
                    status: "",
                });

                setErrors({});
            } else {
                setMessage(response?.message || "Failed to add role");
            }
        } catch (error) {
            setMessage(error?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <h4 className="mb-3">Add New Admin Role</h4>

            <div className="row">
                {/* Left Section */}
                <div className="col-md-6 bg-white p-3 shadow-sm rounded">

                    <form onSubmit={handleSubmit}>

                        {/* Role Name */}
                        <div className="mb-3">
                            <input
                                type="text"
                                name="name"
                                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                placeholder="Enter role name"
                                value={formData.name}
                                onChange={handleChange}
                            />

                            {errors.name && (
                                <div className="invalid-feedback">
                                    {errors.name}
                                </div>
                            )}
                        </div>

                        {/* Status Dropdown */}
                        <div className="mb-3">
                            <select
                                name="status"
                                className={`form-select ${errors.status ? "is-invalid" : ""}`}
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value="">Select Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>

                            {errors.status && (
                                <div className="invalid-feedback">
                                    {errors.status}
                                </div>
                            )}
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </form>

                    {/* Message */}
                    {message && (
                        <div className="mt-3">
                            <CommonMessage text={message} />
                        </div>
                    )}
                </div>
                
            </div>
        </>
    );
};
export default RoleAdd;